import { useState } from 'react';
// We have arrow-down just in case, but I think that's an overkill
import ArrowIcon from '@/assets/img/icon/22x24/arrow-up.svg';

interface AccordionProps {
    question: string;
    answer: string;
    defaultOpen?: boolean;
    className?: string;
}

export const Accordion = ({ 
    question, 
    answer, 
    defaultOpen = false,
    className = '' 
}: AccordionProps) => {
    const [isOpen, setIsOpen] = useState(defaultOpen);

    return (
        <div 
            className={`w-[800px] p-6 bg-gradient-to-br from-white/20 to-white/5 rounded-3xl 
                shadow-[0px_0.96px_23.96px_0px_rgba(69,42,124,0.10)] 
                outline outline-[1.5px] outline-offset-[-1.5px] outline-white/10 
                backdrop-blur-xl inline-flex justify-start items-start gap-6 overflow-hidden
                cursor-pointer transition-all duration-200
                ${!isOpen ? 'opacity-40' : ''} ${className}`}
            onClick={() => setIsOpen(!isOpen)}
        >
            <div className="flex-1 inline-flex flex-col justify-start items-start gap-3">
                <div className="self-stretch justify-start text-white text-xl font-medium font-outfit leading-6">
                    {question}
                </div>
                {isOpen && (
                    <div className="justify-start text-white/60 text-sm font-normal font-outfit leading-5">
                        {answer}
                    </div>
                )}
            </div>
            <div className={`w-6 h-6 relative transition-transform duration-200 ${isOpen ? '' : 'rotate-180'}`}>
                <img src={ArrowIcon} alt="Toggle" className="w-6 h-6" />
            </div>
        </div>
    );
};